module.exports = __webpack_public_path__ + "media/images/tutorial_body_pc3-03-05055c96420bf2d6a118c45fdb2d02ee.png";